import { Chip, ChipProps } from '@mui/material';

interface MuiChipProps extends ChipProps {}

export function MuiChip(props: MuiChipProps) {
  const { sx, ...rest } = props;

  return <Chip sx={{ ...sx }} {...rest} />;
}
